import React, {useEffect, useState} from 'react';
import axios from 'axios';

import Header from "../../components/layout/Header";
import PageTitle from "../../components/layout/PageTitle";
import Wrapper from "../../components/layout/Wrapper";
import Footer from "../../components/layout/Footer";
import CourseCard from "../../components/cards/CourseCard";

import {faUniversity} from '@fortawesome/free-solid-svg-icons';

import {Helmet} from "react-helmet-async";
import {COURSE_API_BASE, SITE_URL} from "../../utils/apiConfig";


const CourseMain = () => {

    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {

        const fetchCourses = async () => {

            try {

                setLoading(true);
                setError(false);

                const response = await axios.get(
                    `${COURSE_API_BASE}/`
                );

                console.log(response);

                if (
                    response.data?.success &&
                    Array.isArray(response.data.courses)
                ) {
                    setCourses(response.data.courses);
                } else {
                    setCourses([]);
                    setError(true);
                }

            } catch (err) {

                console.error(
                    'Error fetching courses:',
                    err
                );

                setCourses([]);
                setError(true);

            } finally {

                setLoading(false);

            }
        };

        fetchCourses();

    }, []);


    return (
        <>
            <Helmet>

                <title>
                    دوره‌های برنامه‌نویسی کدپرو
                </title>

                <link
                    rel="canonical"
                    href={`${SITE_URL}/course/`}
                />

                <meta
                    name="description"
                    content="دوره‌های آموزش برنامه‌نویسی کدپرو؛ آموزش تعاملی HTML، CSS، JavaScript، Python و سایر مهارت‌های برنامه‌نویسی."
                />

            </Helmet>


            <div className="min-h-screen flex flex-col">

                <Header/>


                <main className="flex-1 my-8">

                    <Wrapper>

                        <PageTitle
                            title="دوره‌ها"
                            icon={faUniversity}
                        />


                        <div className="flex flex-1 w-full gap-6">


                            {/* Courses */}

                            <div className="w-full mx-10">

                                {loading && (

                                    <div className="w-full flex justify-center items-center py-20">

                                        <span className="text-gray-500 text-lg">
                                            در حال بارگذاری دوره‌ها...
                                        </span>

                                    </div>

                                )}


                                {!loading && error && (

                                    <div className="w-full flex flex-col justify-center items-center py-20">

                                        <span className="text-gray-500 text-lg">
                                            دریافت دوره‌ها با مشکل مواجه شد.
                                        </span>

                                    </div>

                                )}


                                {!loading &&
                                    !error &&
                                    courses.length === 0 && (

                                        <div className="w-full flex justify-center items-center py-20">

                                            <span className="text-gray-500 text-lg">
                                                هنوز دوره‌ای منتشر نشده است.
                                            </span>

                                        </div>

                                    )}


                                {!loading &&
                                    !error &&
                                    courses.length > 0 && (

                                        <div className="flex flex-wrap">

                                            {courses.map((course) => (

                                                <CourseCard
                                                    key={course.id}
                                                    course={course}
                                                />

                                            ))}

                                        </div>

                                    )}

                            </div>


                        </div>

                    </Wrapper>

                </main>


                <Footer/>

            </div>
        </>
    );
};


export default CourseMain;